@if (item) {
  <div class="vertical-box-item">
    @if (item.image) {
      <div class="image-container alignment-{{item.innerContentAlignment}}">
        <div class="image">
          <a [routerLink]="item.urlButton">
            <cx-media [container]="item.image"></cx-media>
          </a>
        </div>
        @if (item.innerImageTitle) {
          <div class="inner-text" >
            <div
              class="title"
              [style.color]="item.innerImageTitleColor"
              [style.font-size]="item.innerImageTitleSize"
              >
              {{item.innerImageTitle}}
            </div>
          </div>
        }
      </div>
    }
    <div class="bottom-info">
      @if (item.title) {
        @switch (item.titleTag) {
          @case ('H1') {
            <h1
              class="title"
              [style.color]="item.titleColor"
              [style.font-size]="item.titleSize"
              [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
              >
              {{item.title}}
            </h1>
          }
          @case ('H2') {
            <h2
              class="title"
              [style.color]="item.titleColor"
              [style.font-size]="item.titleSize"
              [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
              >
              {{item.title}}
            </h2>
          }
          @default {
            <div
              class="title"
              [style.color]="item.titleColor"
              [style.font-size]="item.titleSize"
              [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
              >
              {{item.title}}
            </div>
          }
        }
      }
      @if (item.text) {
        <div
          class="text"
          [style.color]="item.textColor"
          [style.font-size]="item.textSize"
          >
          {{item.text}}
        </div>
      }
      @if (item.urlButton && item.textButton) {
        <div class="button">
          <a
            [routerLink]="item.urlButton"
            class="btn btn-underline-primary"
            [style.color]="item.textColor"
            >
            {{item.textButton}}
          </a>
        </div>
      }
    </div>
  </div>
}
